import React from 'react';
import { makeStyles } from 'design-system';
import Markdown from '@scale/frontend-lib/markdown';
import Section from './section';
import Example from './example';
import {
  IInstructionExampleJson,
  LabelInstructionJson,
} from '@scale/shared/projectInstruction/types';
import { useProjectInstructionContext } from '../projectInstructionContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Label = ({ contentData }: { contentData: LabelInstructionJson }) => {
  const classes = useStyles();
  const { title, examples, description } = contentData;
  const { isMobileView } = useProjectInstructionContext();
  return (
    <div style={{ display: isMobileView ? 'block' : 'grid' }}>
      {!isMobileView && (
        <div className={classes.titleContainer}>
          <h3 className={classes.title}>{title}</h3>
          {contentData.hiddenFromCustomer && (
            <FontAwesomeIcon className={classes.hideIcon} icon="eye-slash" />
          )}
        </div>
      )}
      {description && (
        <Section sectionName="description">
          <div
            dangerouslySetInnerHTML={{
              __html: Markdown.render(description || ''),
            }}
          />
        </Section>
      )}
      {examples?.length ? (
        <Section sectionName="examples" isNew={false}>
          {examples.map((example: IInstructionExampleJson, index: number) => {
            return (
              <div
                key={`${index}-${index}`}
                style={{
                  borderBottom: index !== examples.length - 1 ? `3px solid #E6E6E6` : 'transparent',
                }}
              >
                <Example key={index} example={example} />
              </div>
            );
          })}
        </Section>
      ) : (
        ''
      )}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 600,
  },
  hideIcon: {
    color: theme.colors.gray50,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export default Label;
